// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__9_KtA","row":"styles_row__2-XR9"};